import React, { useState } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  UploadOutlined,
  UserOutlined,
  FileTextOutlined,
  ProductOutlined,
  GiftOutlined,
  HeartOutlined,
  GatewayOutlined,
  AuditOutlined,
  SettingOutlined,
  TagOutlined,
  GroupOutlined
} from '@ant-design/icons';

import PageRoutes from "./PageRoutes"
import { BrowserRouter, useLocation, useNavigate } from "react-router-dom";

import Menu from "./Menu"
import Header from "./Header"

const App = () => {
  const [collapsed, setCollapsed] = useState(false);


  const menuClick = (e) => {
    window.location = e.key;
  }

  return (
    <BrowserRouter basename="/">


      <Menu></Menu>



      <Header></Header>
      <div style={{ width: "100%", height: 16 }}>

      </div>
      <div style={{ padding: 8 }}>
        <PageRoutes></PageRoutes>
      </div>







    </BrowserRouter>
  );
};

export default App;